"use client";
import { useEffect, useState } from "react";
import { SiteHeader } from "./components/SiteHeader";
import { AppProviders } from "./app/providers/AppProviders";
import { DashboardPage } from "./features/dashboard/pages/DashboardPage";
import { SegmentsPage } from "./features/segments/pages/SegmentsPage";
import { WalletsPage } from "./features/wallets/pages/WalletsPage";
import { UserDashboardPage } from "./features/dashboard/pages/UserDashboardPage";
import { MainV2Page } from "./pages/PlaygroundLegacy";
import { TerminalPage } from "./pages/TerminalPage";
import "./index.css";

/**
 * Router component - handles client-side routing
 */
function Router() {
	const [path, setPath] = useState(window.location.pathname);

	useEffect(() => {
		const handleLocationChange = () => {
			setPath(window.location.pathname);
		};
		window.addEventListener("popstate", handleLocationChange);
		return () => window.removeEventListener("popstate", handleLocationChange);
	}, []);

	if (path === "/legacy") {
		return <MainV2Page />;
	}

	return (
		<>
			<SiteHeader path={path} />
			<Page path={path} />
		</>
	);
}

function Page({ path }: { path: string }) {
	if (path === "/wallets" || path.startsWith("/wallets/")) {
		return <WalletsPage />;
	}

	if (path === "/segments" || path.startsWith("/segments/")) {
		return <SegmentsPage />;
	}

	if (path.startsWith("/dashboard/users") || path.startsWith("/users")) {
		return <UserDashboardPage />;
	}

	if (path === "/dashboard" || path.startsWith("/dashboard/")) {
		return <DashboardPage />;
	}

	return <TerminalPage />;
}

/**
 * App component with providers
 *
 * Wraps the application with terminal providers and SWR config.
 */
export function App() {
	return (
		<AppProviders>
			<Router />
		</AppProviders>
	);
}

export default App;
